// קבועים של משפטים לפי רמות ציון
// Constants for feedback messages by score levels

export const highScoreFeedback: [string, string?][] = [
  ["אינו דומה שונה פרקו מאה פעמים לשונה מאה ואחד!", "חגיגה ט:"],
  ["ראיתי בני עלייה והן מועטין!", "סוכה מה:"],
  ["וטוב לב משתה תמיד - זה בעל משנה", "בבא בתרא קמה:"],
  ["במי אתה מוצא מלחמתה של תורה? במי שיש בידו חבילות של משנה", "סנהדרין מב"],
  ["'אשר תשמרון' - זו משנה, 'לעשות' - זה מעשה", "קידושין לז"],
  ["ומשנה מביאה לידי יראה", "ספרי שופטים קס\"א"],
  ["'עמוד ברזל' - משנה", "ויקרא רבה כה,א"],
  ["אשרי מי שבא לכאן ותלמודו בידו", "פסחים נ."],
  ["תלמידי חכמים מרבים שלום בעולם", "ברכות סד."],
  ["כל העוסק בתורה לשמה זוכה לדברים הרבה", "אבות ו, א"],
  ["דברי תורה כדרבונות וכמסמרות נטועים", "חגיגה ג:"],
  ["אין התורה נקנית אלא בחבורה", "ברכות סג:"]
];

export const mediumScoreFeedback: [string, string?][] = [
  ["אתה שנון!"],
  ["יגעת ומצאת!", "מגילה ו:"],
  ["ולעולם הוי רץ למשנה יותר מן הגמרא", "בבא מציעא לג"],
  ["הואיל ואתם מתעסקים במשנה - כאילו אתם מקריבין קרבן", "ויקרא רבה ז,ג"],
  ["אין כל הגלויות הללו מתכנסות אלא בזכות משניות", "ויקרא רבה ז,ג"],
  ["'ויקץ יעקב משנתו' - ר' יוחנן אמר: ממשנתו"],
  ["חביבין דברי סופרים יותר מיינה של תורה", "עבודה זרה לה."],
  ["טובה חכמה עם נחלה", "קהלת ז, יא"],
  ["אין הברכה מצויה אלא בדבר הסמוי מן העין", "תענית ח:"],
  ["גדול הנהנה מיגיעו יותר מירא שמים", "ברכות ח."],
  ["סייג לחכמה שתיקה", "אבות ג, יג"]
];

export const lowScoreFeedback: [string, string?][] = [
  ["חזק ואמץ!"],
  ["כל הכבוד!"],
  ["ברוך תהיה!"],
  ["יישר כחך!"],
  ["אם ראית תלמיד שלמודו קשה עליו כברזל - בשביל משנתו שאינה סדורה עליו", "ריש לקיש"],
  ["ולמדתם אותם את בניכם!", "דברים יא, יט"],
  ["הפוך בה והפוך בה דכולא בה", "אבות ה, כב"],
  ["לעולם ישלש אדם שנותיו: שליש במקרא, שליש במשנה", "קידושין ל."],
  ["אין אדם עומד על דברי תורה אלא אם כן נכשל בהן", "גיטין מג."],
  ["יגעתי ולא מצאתי - אל תאמין", "מגילה ו:"],
  ["מתוך שלא לשמה בא לשמה", "פסחים נ:"],
  ["לעולם יהא אדם ענוותן כהלל", "שבת ל:"]
];

// English version - quotes remain in Hebrew, source references translated to English
export const highScoreFeedbackEn: [string, string?][] = [
  ["אינו דומה שונה פרקו מאה פעמים לשונה מאה ואחד!", "Chagigah 9a"],
  ["ראיתי בני עלייה והן מועטין!", "Sukkah 45a"],
  ["וטוב לב משתה תמיד - זה בעל משנה", "Bava Batra 145a"],
  ["במי אתה מוצא מלחמתה של תורה? במי שיש בידו חבילות של משנה", "Sanhedrin 42"],
  ["'אשר תשמרון' - זו משנה, 'לעשות' - זה מעשה", "Kiddushin 37"],
  ["ומשנה מביאה לידי יראה", "Sifrei Shoftim 161"],
  ["'עמוד ברזל' - משנה", "Vayikra Rabbah 25:1"],
  ["אשרי מי שבא לכאן ותלמודו בידו", "Pesachim 50a"],
  ["תלמידי חכמים מרבים שלום בעולם", "Berachot 64a"],
  ["כל העוסק בתורה לשמה זוכה לדברים הרבה", "Avot 6:1"],
  ["דברי תורה כדרבונות וכמסמרות נטועים", "Chagigah 3a"],
  ["אין התורה נקנית אלא בחבורה", "Berachot 63a"]
];

export const mediumScoreFeedbackEn: [string, string?][] = [
  ["You are sharp!"],
  ["יגעת ומצאת!", "Megillah 6a"],
  ["ולעולם הוי רץ למשנה יותר מן הגמרא", "Bava Metzia 33"],
  ["הואיל ואתם מתעסקים במשנה - כאילו אתם מקריבין קרבן", "Vayikra Rabbah 7:3"],
  ["אין כל הגלויות הללו מתכנסות אלא בזכות משניות", "Vayikra Rabbah 7:3"],
  ["'ויקץ יעקב משנתו' - ר' יוחנן אמר: ממשנתו"],
  ["חביבין דברי סופרים יותר מיינה של תורה", "Avodah Zarah 35a"],
  ["טובה חכמה עם נחלה", "Kohelet 7:11"],
  ["אין הברכה מצויה אלא בדבר הסמוי מן העין", "Ta'anit 8a"],
  ["גדול הנהנה מיגיעו יותר מירא שמים", "Berachot 8a"],
  ["סייג לחכמה שתיקה", "Avot 3:13"]
];

export const lowScoreFeedbackEn: [string, string?][] = [
  ["Be strong and courageous!"],
  ["Well done!"],
  ["Blessed be you!"],
  ["Keep it up!"],
  ["אם ראית תלמיד שלמודו קשה עליו כברזל - בשביל משנתו שאינה סדורה עליו", "Reish Lakish"],
  ["ולמדתם אותם את בניכם!", "Devarim 11:19"],
  ["הפוך בה והפוך בה דכולא בה", "Avot 5:22"],
  ["לעולם ישלש אדם שנותיו: שליש במקרא, שליש במשנה", "Kiddushin 30a"],
  ["אין אדם עומד על דברי תורה אלא אם כן נכשל בהן", "Gittin 43a"],
  ["יגעתי ולא מצאתי - אל תאמין", "Megillah 6a"],
  ["מתוך שלא לשמה בא לשמה", "Pesachim 50a"],
  ["לעולם יהא אדם ענוותן כהלל", "Shabbat 30a"]
]; 